module.exports = __webpack_public_path__ + "static/media/world.392bc310.svg";